import { useEffect, useMemo, useState } from 'preact/hooks';
import { I18nContext, applyLang, initialLang, translate, type I18n, type Lang } from './i18n';
import { inviteFromHash } from './lib/register-api';
import { RegisterPage } from './pages/Register';

// The public shell for the supplier form (P2.4): logo, language switch, no menus and no sign-in.
// main.tsx picks it for `#/register`, so Microsoft sign-in never starts for a supplier.

export function RegisterApp() {
  const [lang, setLang] = useState<Lang>(initialLang);
  useEffect(() => applyLang(lang), [lang]);
  const i18n = useMemo<I18n>(
    () => ({ lang, setLang, t: (key, vars) => translate(lang, key, vars) }),
    [lang],
  );
  const { t } = i18n;
  const [token] = useState(() => inviteFromHash(location.hash));

  return (
    <I18nContext.Provider value={i18n}>
      <a class="skip-link" href="#main">
        {t('skip')}
      </a>
      <header class="app-header">
        <div class="app-header__row">
          <span class="brand">
            <img src="/brand/smc-group.svg" alt="SMC Group" width="77" height="30" />
            <span class="brand__word">{t('app.name')}</span>
          </span>
          <div class="app-header__end">
            <button
              type="button"
              class="lang-switch"
              lang={lang === 'en' ? 'ar' : 'en'}
              aria-label={t('lang.switchLabel')}
              onClick={() => setLang(lang === 'en' ? 'ar' : 'en')}
            >
              {t('lang.switch')}
            </button>
          </div>
        </div>
        <div class="entity-stripe" aria-hidden="true">
          <span class="entity-stripe__smc" />
          <span class="entity-stripe__vibes" />
          <span class="entity-stripe__media" />
        </div>
      </header>
      <main id="main" class="page" tabIndex={-1}>
        <h1 class="page__title">{t('reg.title')}</h1>
        <RegisterPage token={token} />
      </main>
    </I18nContext.Provider>
  );
}
